export function removeStorageItem(storageKey: string, name: string) {
    try {
        const params = JSON.parse(localStorage.getItem(storageKey) || '{}');
        delete params[name];
        localStorage.setItem(storageKey, JSON.stringify(params));
    } catch (e) {
        localStorage.setItem(storageKey, JSON.stringify({}));
    }
}
